// extracted by mini-css-extract-plugin
module.exports = {"BooleanListFeature":"vt_a bgu_b"};